import React, { useEffect } from 'react';

export default function AdBanner() {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // adsbygoogle may not be available (e.g. blocked by an ad blocker); ignore gracefully
    }
  }, []);

  return (
    <div className="ad-sidebar">
      <ins
        className="adsbygoogle"
        style={{ display: 'inline-block', width: '160px', height: '600px' }}
        data-ad-client="ca-pub-7799713541249640"
        data-ad-slot="XXXXXXXXXX"
      />
    </div>
  );
}
